import DonationFeed from './DonationFeed'

export default DonationFeed
